import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BookOpen, Calendar } from "lucide-react";

export default function Liturgical() {
    const [today, setToday] = useState(null);
    const [list, setList] = useState([]);

    useEffect(() => {
        api.get("/liturgical/today").then(({ data }) => setToday(data)).catch(() => {});
        api.get("/liturgical").then(({ data }) => setList(data)).catch(() => {});
    }, []);

    if (!today || !today.date) {
        return (
            <div className="parchment min-h-[calc(100vh-4rem)]">
                <div className="mx-auto max-w-3xl px-6 md:px-10 py-16 text-center">
                    <div className="font-display text-4xl" style={{ color: "#1E1B4B" }}>Today’s reading is being prepared.</div>
                    <p className="mt-3" style={{ color: "#525252" }}>Please check back shortly.</p>
                </div>
            </div>
        );
    }

    const blocks = [
        { label: "The Word of God", body: today.word_of_god },
        { label: "First Reading", body: today.first_reading },
        { label: "Psalm", body: today.psalm },
        { label: "Acclamation", body: today.acclamation },
        { label: "Gospel", body: today.gospel },
        { label: "A note for this feast", body: today.note },
    ].filter((b) => b.body);

    return (
        <div className="parchment min-h-[calc(100vh-4rem)]">
            <div className="mx-auto max-w-4xl px-6 md:px-10 py-12">
                <div className="text-xs tracking-[0.28em] uppercase flex items-center gap-2" style={{ color: "#7F1D1D" }}>
                    <BookOpen size={14} /> The Catholic Liturgical Calendar
                </div>
                <h1 className="font-display text-4xl sm:text-5xl mt-2" style={{ color: "#1E1B4B" }}>{today.feast || "Today’s Reading"}</h1>
                <div className="mt-2 text-sm flex items-center gap-2" style={{ color: "#525252" }}>
                    <Calendar size={14} /> {today.date}
                </div>

                <div className="gold-divider my-8" />

                <article className="space-y-8">
                    {blocks.map((b, i) => (
                        <section key={i} data-testid={`liturgical-block-${i}`}>
                            <div className="text-xs tracking-[0.22em] uppercase mb-2" style={{ color: "#7F1D1D" }}>{b.label}</div>
                            <div className="font-display text-xl sm:text-2xl leading-relaxed" style={{ color: "#1E1B4B" }}>{b.body}</div>
                        </section>
                    ))}
                </article>

                {list.length > 1 && (
                    <div className="mt-16">
                        <div className="text-xs tracking-[0.22em] uppercase mb-3" style={{ color: "#7F1D1D" }}>Previous days</div>
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                            {list.slice(1, 10).map((l) => (
                                <div key={l.date} className="p-card p-4" data-testid={`liturgical-prev-${l.date}`}>
                                    <div className="text-xs" style={{ color: "#525252" }}>{l.date}</div>
                                    <div className="font-display text-lg" style={{ color: "#1E1B4B" }}>{l.feast || "Ordinary Time"}</div>
                                    <div className="text-sm mt-1 line-clamp-2" style={{ color: "#525252" }}>{l.word_of_god}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
